<div class="sidebar"
    [class.sidebar--header]="isHeaderVariant"
    (mouseenter)="sidebarHoverIn()"
    (mouseleave)="sidebarHoverpOut()"
    [ngStyle]="isHeaderVariant ? null : {'width': isFullWidth ? '250px' : '60px'}"
    [ngClass]="{'sidebar-collapsed': !isFullWidth && !isHeaderVariant}">

    <ul [class.mt-6]="!isHeaderVariant" [class.header-menu-list]="isHeaderVariant">

        @if (!isHeaderVariant) {
        <div class="sidebar-brand-row">
            <a routerLink="/" class="sidebar-brand" [class.sidebar-brand--compact]="!isFullWidth">
                <img src="assets/images/sharjah-airport-logo.svg" alt="Sharjah Airport" class="sidebar-logo">
            </a>
            @if(!sidebarDynamicStatus){
            <div class="flex justify-content-end align-items-center px-2">
                <div class="font-bold cursor-pointer toggle-btn" (click)="toggletSideBar(true)">
                    <i class="pi pi-thumbtack"></i>
                </div>
            </div>
            }
            @if(sidebarDynamicStatus){
            <div class="flex justify-content-end align-items-center px-2">
                <div class="font-bold cursor-pointer toggle-btn toggle-btn-active" (click)="toggletSideBar(false)">
                    <i class="pi pi-thumbtack"></i>
                </div>
            </div>
            }
        </div>
        }

        @for(item of menuItems; track item)
        {
        <li [className]="item.children?.length?'subMenu__parent':''"
            [class.header-menu-item]="isHeaderVariant">
            <a routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: false }"
                [ngClass]="{ active: !item.children?.length && item.active }"
                [routerLink]="item.type=='sub' ? null : [item.path]"
                class="sidebar-header"
                (click)="toggletNavActive(item)">
                <div [ngClass]="{'icon--rtl':dir=='rtl','icon--ltr':dir=='ltr'}" class="text-center"
                    style='min-width:1.7rem'>
                    <i class="fa-solid {{item.icon}}"></i>
                </div>

                @if(isFullWidth || isHeaderVariant){
                <span [ngClass]="{'ml-2':dir=='rtl','mr-2':dir=='ltr'}" [title]="item.title">{{item.title}}</span>
                }
                @if(item.children?.length) {
                <i class="fa-solid list-icon"
                    [class.fa-caret-up]="item.active"
                    [class.fa-caret-down]="!item.active"></i>
                }
            </a>

            @if (!isHeaderVariant) {
            <div class="menu-divider" *ngIf="!item.children?.length"></div>
            }

            @if(item.active && item.children?.length){
            <ul class="sidebar-submenu"
                [ngClass]="{'menu-open': item.active, 'menu-close': !item.active, 'header-submenu': isHeaderVariant}">
                @for(child of item.children; track child)
                {
                <li (click)="toggletNavActive(child)">
                    <a class="child-link" routerLinkActive="active"
                        [routerLink]="child.type=='link' ? [child.path] : null"
                        [title]="child.title">
                        <div class="child-item">
                            @if (child.icon) {
                            <i class="child-icon" [class]="child.icon"></i>
                            }
                            <span class="child-title">{{ child.title}}</span>
                        </div>
                    </a>
                </li>
                }
            </ul>
            }
        </li>
        }
    </ul>
</div>
